module.exports = __webpack_public_path__ + "h5/img/bs_05.de304201.jpg";